module.exports = __webpack_public_path__ + "static/media/core-1.621f5b74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/core-1.svg
// module id = 1111
// module chunks = 2